import gql from 'graphql-tag';

export const isPrimaryApplicantQuery = gql`
  query IsPrimaryApplicantQuery($companyProfileId: ID!) {
    viewer {
      uid
      companyUser(companyProfileId: $companyProfileId) {
        companyUserId
        isPrimaryApplicant
      }
    }
  }
`;
